import globalMeta from '@/constants/global-meta';
import Head from 'next/head';

export default function SEOHead({
  title = globalMeta.siteName,
  description = globalMeta.description,
  canonicalUrl = globalMeta.siteUrl,
  twitterTitle = ``,
  ogTitle = ``,
  ogType = globalMeta.ogType,
  ogImgUrl = globalMeta.siteLogo,
  children = undefined as React.ReactNode,
}) {
  if (twitterTitle === ``) {
    twitterTitle = title.replace(` - O Amarelinho`, ``);
  }

  if (ogTitle === ``) {
    ogTitle = title.replace(` - O Amarelinho`, ``);
  }

  return (
    <Head>
      {/*
        	Fundamental head elements important for SEO.
    	*/}
      <title>{title}</title>
      <meta name="author" content="O Amarelinho" />
      <meta name="publisher" content="O Amarelinho" />
      <meta name="copyright" content="O Amarelinho" />
      <meta name="host" content={canonicalUrl} />
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="icon" href="/favicon.ico" />

      {/*
        	Open graph meta tags.
    	*/}
      <meta property="og:locale" content="pt_BR" />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:type" content={ogType} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImgUrl} />
      <meta name="og:site_name" content="O Amarelinho" />
      <meta property="og:url" content={canonicalUrl} />

      {/*
        	Twitter meta tags.
    	*/}
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="oamarelinho.com.br" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={twitterTitle} />
      <meta name="twitter:site" content="@OAmarelinho" />
      <meta name="twitter:creator" content="@OAmarelinho" />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImgUrl} />

      {/* Children */}
      {children}
    </Head>
  );
}
